let data=[
    {
        id:1,
        img:'/img/summer/summer01.gif',
        description: 'ts4533 (MADE/부유방커버/탄탄쫀쫀/자수포인트♥) Petite Note No.13 토비 배색 자수 코튼 나시 티셔츠',
        price:25000,
        discount:18000,
        sale:'35%',
        title:'Petite Note No.13 토비 배색 자수 코튼 나시 티셔츠',
        company:'올데이, 다다이득'
    },
    {
        id:2,
        img:'/img/summer/summer02.gif',
        description: 'ts4557 (MADE/탄탄봉제/넥라인늘어짐zero/핏예쁜베이직♥) Petite Note No.15 미코니 골지 코튼 반팔 티셔츠',
        price:20000,
        discount:15000,
        sale:'25%',
        title:'Petite Note No.15 미코니 골지 코튼 반팔 티셔츠',
        company:'올데이, 1+1 기획상품'
    },
    {
        id:3,
        img:'/img/summer/summer03.gif',
        description: 'bs8144 (셔츠전문공장제작/여름기능성원단) 마요르카 루즈핏 카라 셔츠 남방',
        price:59000,
        discount:39500,
        sale:'33%',
        title:'마요르카 루즈핏 카라 셔츠 남방',
        company:'올데이'
    },
    {
        id:4,
        img:'/img/summer/summer04.gif',
        description: 'ps5305 (MADE/2기장/매끈찰랑/링클프리/비침↓) 비엘로 2기장 실크 라이크 찰랑 밴딩 와이드 팬츠',
        price:38000,
        discount:29000,
        sale:'24%',
        title:'비엘로 2기장 실크 라이크 찰랑 밴딩 와이드 팬츠',
        company:'올데이'
    },
    {
        id:5,
        img:'/img/summer/summer05.gif',
        description: 'op16056 (2기장/브랜드퀄리티/여름격식룩) 셀리 2기장 트위드 스퀘어넥 A라인 반팔 미니 원피스',
        price:98000,
        discount:76000,
        sale:'30%',
        title:'셀리 2기장 트위드 스퀘어넥 A라인 반팔 미니 원피스',
        company:'아뜨랑스'
    },
    {
        id:6,
        img:'/img/summer/summer06.gif',
        description: 'bs8205 (2way/오프숄더/러블리무드) 뮤잉 밴딩 리본 캉캉 반팔 블라우스',
        price:23000,
        discount:17800,
        sale:'30%',
        title:'뮤잉 밴딩 리본 캉캉 반팔 블라우스',
        company:'아뜨랑스'
    },
    {
        id:7,
        img:'/img/summer/summer07.gif',
        description: 'bs8128 (살안타템/핀터레스트무드낭낭♥) 베아트리 핀턱 프릴 레이스 후드 블라우스',
        price:40000,
        discount:22000,
        sale:'50%',
        title:'베아트리 핀턱 프릴 레이스 후드 블라우스',
        company:'아뜨랑스'
    },
    {
        id:8,
        img:'/img/summer/summer08.gif',
        description: 'op16035 (백화점납품/브랜드공정/격식룩) 모디프 포켓 버튼 트위드 H라인 롱 반팔 원피스',
        price:128000,
        discount:89000,
        sale:'37%',
        title:'모디프 포켓 버튼 트위드 H라인 롱 반팔 원피스',
        company:'아뜨랑스'
    },
    {
        id:9,
        img:'/img/summer/summer09.gif',
        description: 'op15973 (신상♥/브랜드공정/고퀄리티) 올리비아 오간자 시스루 하트넥 쉬폰 반팔 플레어 롱 원피스',
        price:98000,
        discount:68000,
        sale:'37%',
        title:'올리비아 오간자 시스루 하트넥 쉬폰 반팔 플레어 롱 원피스',
        company:'아뜨랑스'
    },
    {
        id:10,
        img:'/img/summer/summer10.gif',
        description: 'nt5089 (MADE/통기성굿/부유방커버/색감맛집♥) Petite Note No.14 노엘 스퀘어넥 니트 슬리브리스',
        price:22000,
        discount:19500,
        sale:'35%',
        title:'Petite Note No.14 노엘 스퀘어넥 니트 슬리브리스',
        company:'올데이, 다다이득'
    }
]

export default data;